<div class="tagbadge cursor clickable" *ngIf="person !== undefined">
    <div class="d-flex">
        <!-- <img src="..." class="align-self-center me-3" alt="..."> -->
        <i class="fa fa-user-circle align-self-center me-2" aria-hidden="true"></i>
        <div class="flex-grow-1">
          <span class="mt-0 mb-0">{{person.name}}</span>
        </div>
    </div>
</div>